import BaseRecaptcha from 'react-google-recaptcha'
import { forwardRef } from 'react'

export const Recaptcha = forwardRef((props, ref) => {
  return (
    window.env.recaptcha.enabled && (
      <BaseRecaptcha
        sitekey={window.env.recaptcha.key}
        ref={ref}
        {...props}
      />
    )
  )
})
